import { LogicalOperator } from './query-types';

export function getLogicalOperatorString(operator: LogicalOperator): string {
  switch (operator) {
    case LogicalOperator.And:
      return 'AND';
    case LogicalOperator.Or:
      return 'OR';
    default:
      throw new Error(`Invalid logical operator: ${operator}`);
  }
}
